import React, { useCallback, useState } from 'react';
import { useAuth } from 'react-oidc-context';

import CircleHelpIcon from '@liquidweb-dev/undercurrent/icons/lucide/CircleHelp';
import IconButton from '@liquidweb-dev/undercurrent/IconButton';
import Link from '@liquidweb-dev/undercurrent/Link';
import ListItemText from '@liquidweb-dev/undercurrent/ListItemText';
import Menu from '@liquidweb-dev/undercurrent/Menu';
import MenuItem from '@liquidweb-dev/undercurrent/MenuItem';
import Tooltip from '@liquidweb-dev/undercurrent/Tooltip';

import { IntroTarget, introTargets } from 'containers/introjs';
import startChatProgrammatically from 'utility/chat/startChatProgrammatically';
import HookedLink from './HookedLink';
import useLeftHandLayout from '../context';

export function TopNavSupport() {
	const [menuElement, setMenuElement] = useState();
	const open = menuElement !== undefined;

	const { roles } = useLeftHandLayout();

	const { user } = useAuth();
	const currentUser = user?.profile?.username;

	const handleClose = useCallback(() => {
		setMenuElement();
	}, []);

	const handleChat = useCallback(() => {
		startChatProgrammatically();
		handleClose();
	}, [handleClose]);

	if (!roles.loggedIn) {
		return null;
	}

	return (
		<>
			<Tooltip title="Support">
				<IntroTarget introId={introTargets.navHelpMenu}>
					<IconButton
						onClick={({ currentTarget }) => setMenuElement(currentTarget)}
					>
						<CircleHelpIcon sx={{ height: '16px', width: '16px' }} />
					</IconButton>
				</IntroTarget>
			</Tooltip>
			<Menu
				open={open}
				anchorEl={menuElement}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'right',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'right',
				}}
				onClose={handleClose}
				sx={{ zIndex: { xs: 1201, sm: 1200 } }}
			>
				<MenuItem
					component={HookedLink}
					href="/support"
					onClick={handleClose}
					role="menuitem"
				>
					<ListItemText primary="Support center" />
				</MenuItem>
				<MenuItem
					component={HookedLink}
					href="/support/mycases"
					onClick={handleClose}
					role="menuitem"
				>
					<ListItemText primary="My cases" />
				</MenuItem>
				<MenuItem onClick={handleChat} role="menuitem">
					<ListItemText primary="Chat with Support" />
				</MenuItem>
				<MenuItem
					component={Link}
					href="https://www.liquidweb.com/help-docs/"
					target="_blank"
					onClick={handleClose}
					role="menuitem"
				>
					<ListItemText primary="Help Docs" />
				</MenuItem>
				<MenuItem
					component={HookedLink}
					href={`/account/users/${currentUser}`}
					onClick={handleClose}
					role="menuitem"
				>
					<ListItemText primary="My support passphrase" />
				</MenuItem>
			</Menu>
		</>
	);
}

export default TopNavSupport;
